export const LEGAL_LINKS = {
	privacy: '/PRIVACY POLICY.pdf',
	terms: '/SoftAI regulamin terms of use.pdf',
};
